import AppContext from '../../controllers/AppContext';
import logService from '../wss/logService3';
import { publish } from '../utils/pubsub';
import { events } from '../wss/SystemEvents';

/**
 * Base class for all engines and services.
 * Provides token access, error handling and logging.
 */
export default class CoreBase {
    _name = 'CoreBase';

    /**
     * Returns the current JWT token from AppContext — synchronous, no async needed.
     * @returns {string|null}
     */
    getToken = () => AppContext.getToken();

    /**
     * Returns the current user ID from AppContext — synchronous, no async needed.
     * @returns {string|null}
     */
    getUid = () => AppContext.getUid();

    /**
     * Returns the current tab ID from AppContext — synchronous, no async needed.
     * @returns {string|null}
     */
    getTabId = () => AppContext.getTabId();

    /**
     * Returns the window geo scope (tabId + active workspace) from AppContext.
     * @returns {string|null}
     */
    getGeoScopeId = () => AppContext.getGeoScopeId();

    /**
     * Publishes a message event — consumed by toast/notification handler.
     * @param {string} message
     * @param {string} type - 'success' | 'error' | 'info'
     */
    onMessage = (message, type = 'info') => {
        publish(events.onMessage, { source: this._name, message, type });
    };

    /**
     * Publishes an error event via pubsub — caught by ErrorEngine, no direct coupling.
     * @param {string} message
     * @param {*} data
     */
    onError = (message, data = null) => {
        const item = { source: this._name, message, data };
        publish(events.onError, item);
    };

    /**
     * Logs an error via logService and publishes to ErrorEngine via onError.
     * @param {string} method
     * @param {string} message
     */
    logError = (method, message) => {
        const msg = `${this._name}.${method}: ${message}`;
        logService.logError(msg);
        this.onError(msg);
    };

    /**
     * Logs a debug message via logService.
     * @param {string} method
     * @param {string} message
     */
    logDebug = (method, message) => {
        logService.log(`${this._name}.${method}: ${message}`);
    };
}
